import { render, staticRenderFns } from "./PackageTextsForm.vue?vue&type=template&id=7c87f466&scoped=true"
import script from "./PackageTextsForm.vue?vue&type=script&lang=js"
export * from "./PackageTextsForm.vue?vue&type=script&lang=js"
import style0 from "./PackageTextsForm.vue?vue&type=style&index=0&id=7c87f466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87f466",
  null
  
)

export default component.exports